module.exports = __webpack_public_path__ + "dbfaff742badf82e9d8044b398369acd.png";